import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';

import Modal from 'components/Modal';

import './style.scss';

const CommonModal = ({
  isOpen,
  className,
  header,
  headerClassName,
  body,
  bodyClassName,
  footer,
  footerClassName,
  closeOnEsc,
  onCloseRequest,
}) => (
  <Modal
    className={className}
    closeOnEsc={closeOnEsc}
    isOpen={isOpen}
    styleName="modal-container"
    onCloseRequest={onCloseRequest}
  >
    {header && (
      <div
        className={headerClassName}
        data-test="modal-header"
        styleName="header"
      >
        {header}
      </div>
    )}

    {body && (
      <div className={bodyClassName} data-test="modal-body" styleName="body">
        {body}
      </div>
    )}

    {footer && (
      <div className={footerClassName} styleName="footer">
        {footer}
      </div>
    )}
  </Modal>
);

CommonModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  body: PropTypes.node,
  bodyClassName: PropTypes.string,
  className: PropTypes.string,
  closeOnEsc: PropTypes.bool,
  footer: PropTypes.node,
  footerClassName: PropTypes.string,
  header: PropTypes.node,
  headerClassName: PropTypes.string,

  onCloseRequest: PropTypes.func,
};

CommonModal.defaultProps = {
  headerClassName: '',
  bodyClassName: '',
  footerClassName: '',
  closeOnEsc: false,

  onCloseRequest: noop,
};

export default CommonModal;
